import { Stack, Typography } from "@mui/material";

const CalculatorFilterMobileHeader = ({data}) => {
    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                spacing={1.5}
            >
                <Typography
                    fontWeight={700}
                    fontSize={24}
                    letterSpacing={0.36}
                    color="rgba(34, 41, 46, 1)"
                    textAlign='center'
                >
                    {data.title}
                </Typography>

                <Typography
                    fontWeight={400}
                    fontSize={14}
                    letterSpacing={0.5}
                    color="rgba(128, 138, 147, 1)"
                    textAlign='center'
                >
                    {data.description}
                </Typography>
            </Stack>
        </>
    );
}

export default CalculatorFilterMobileHeader;